
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedLowDown as ObiSpeedLowDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-low-down.js';
 
 
 

 
 export const ObiSpeedLowDown = createComponent({
   react: React,
   tagName: 'obi-speed-low-down',
   elementClass: ObiSpeedLowDownElement,
   events: {
     
   }
  });
 
 